import React from 'react';
import { Route } from 'react-router';

import Messages from '../../components/Pages/Messages';


const routes = <Route path="messages" component={Messages.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/messages.js